import { tryGetGroupAndSmallDLRecipients } from './tryGetGroupAndSmallDLRecipients';
import { RecipientMemberInfo } from 'owa-recipient-types/lib/types/RecipientMemberInfo';
import {
    SharingTipRecipientInfo,
    lazyHasLargeDLRecipient,
    lazyhasRecipientExpansionFailure,
    lazyGetInvididualRecipients,
} from 'owa-sharing-data';

export async function getAllRecipients(
    linkIds: string[],
    recipientInfos: SharingTipRecipientInfo[],
    composeId: string
): Promise<RecipientMemberInfo[]> {
    const hasLargeDLRecipient = await lazyHasLargeDLRecipient.import();
    const hasRecipientExpansionFailure = await lazyhasRecipientExpansionFailure.import();
    if (hasLargeDLRecipient(recipientInfos) || hasRecipientExpansionFailure(recipientInfos)) {
        return [];
    }

    const [smallDLExpansionSucceeded, allRecipients] = await tryGetGroupAndSmallDLRecipients(
        linkIds,
        recipientInfos,
        composeId
    );
    if (!smallDLExpansionSucceeded) {
        return [];
    }

    // get individual recipients
    const getInvididualRecipients = await lazyGetInvididualRecipients.import();
    const individuals: SharingTipRecipientInfo[] = getInvididualRecipients(recipientInfos);
    individuals.forEach(function (individual) {
        allRecipients.push({
            emailAddress: individual.recipient.persona.EmailAddress.EmailAddress,
            displayName: individual.recipient.persona.EmailAddress.Name,
            personaTypeString: null, // check perm doesn't use this property, null is fine.
        });
    });

    return allRecipients;
}
